import React, { useState, useEffect } from "react";
import ResponsivePagination from "react-responsive-pagination";
import defaultProfileIcon from "../../assets/images/defaultProfileIcon.svg";
import { Link } from "react-router-dom";
import OutsideClickHandler from "../../common/OutsideClickHandler";

const ProvidersSearchResults = ({
  providerSearch,
  onUpdate,
  searchproviderparams,
  providerErrMsg,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const totalPages = Math.ceil(providerSearch?.totalItems / 10);
  const [showError, setShowError] = useState(false);


  useEffect(() => {
    if (providerSearch?.items) {
      setSearchResults(providerSearch.items);
    }
  }, [providerSearch]);

  useEffect(() => {
    if (providerErrMsg) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [providerErrMsg]);

  const handleItemClick = (id) => () => {
    setSelectedItem(id === selectedItem ? null : id);
  };

  const RenderSearchError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {providerErrMsg}
      </div>
    );
  };

  const renderSearch = (item, index) => {
    return (
      <li key={index}>
        <div className="img-container pull-left">
          {item.image ? (
            <img src={item?.image?.small} alt="" />
          ) : (
            <img src={defaultProfileIcon} alt="" />
          )}
        </div>
        <div className="provider-info-right">
          <h3>
            <Link
            onClick={() => {
                // Clear search input when navigating
                const inputRef = document.querySelector('input[type="search"]');
                if (inputRef) {
                  inputRef.value = "";
                }
              }}
              to={`/provider/${item.displayId}/profile-information/info`}
              className="provider-name-link"
            >
              {item?.firstName} {item?.lastName}
            </Link>
          </h3>
          <ul className="list-inline info-list">
            <li className="left-padding-zero">
              <label>Status</label>
              <p>{item?.state}</p>
            </li>
            <li>
              <label>NPI</label>
              <p>{item?.nationalProviderIdentifier}</p>
            </li>
            <li className="license-list">
              <label>License</label>
              {(!item?.licenseNumbers ||
                item?.licenseNumbers?.length === 0) && <p>&nbsp;</p>}
              {item?.licenseNumbers?.length == 1 && (
                <p>{item?.licenseNumbers}</p>
              )}
              {item?.licenseNumbers?.length > 1 && (
                <>
                  <OutsideClickHandler
                    onClickOutside={() => {
                      if (selectedItem === item?.displayId) {
                        setSelectedItem(null);
                      }
                    }}
                  >
                    <p>{item?.licenseNumbers[0]}</p>
                    <a
                      className="more-btn"
                      onClick={handleItemClick(item?.displayId)}
                    >
                      {" "}
                      & {item?.licenseNumbers?.length - 1} more
                      {selectedItem === item?.displayId && (
                        <span className="practice-popover-contect">
                          <div className="arrow"></div>
                          <ul className="more-list">
                            {item?.licenseNumbers?.map((data, index) => (
                              <li key={index}>
                                <b>{index + 1} of {item?.licenseNumbers?.length} - </b>{data}
                              </li>
                            ))}
                          </ul>
                        </span>
                      )}
                    </a>
                  </OutsideClickHandler>
                </>
              )}
            </li>
            <li>
              <label>Locations</label>
              {(!item?.activeLocation ||
                item?.activeLocation?.length === 0) && <p>&nbsp;</p>}
              {item?.activeLocation?.length == 1 && (
                <p>{item?.activeLocation}</p>
              )}
              {item?.activeLocation?.length > 1 && (
                <p className="bold-letter">
                  {item?.activeLocation?.length}
                  {" Active Locations in "}
                  {item?.activeLocationAddressStates?.join(",")}
                </p>
              )}
            </li>
          </ul>
        </div>
      </li>
    );
  };

  return (
    <div className="provider-list">
      {RenderSearchError()}
      {searchResults && (
        <>
          <ul className="search-list">
            {searchResults?.map((item, index) => {
              return renderSearch(item, index);
            })}
          </ul>
        </>
      )}
      {providerSearch?.totalItems > 10 && (
        <div className="paginate-block">
          <ResponsivePagination
            total={totalPages}
            current={searchproviderparams.pageNumber}
            onPageChange={(page) => onUpdate(page)}
          />
        </div>
      )}
    </div>
  );
};
export default ProvidersSearchResults;
